var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeller(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 64C14.327 64 0 49.674 0 32S14.327 0 32 0c17.674 0 32 14.326 32 32S49.673 64 32 64z",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.179 39.028c0 2.802-1.869 4.48-4.62 4.48H24.44c-2.75 0-4.619-1.678-4.619-4.48 0-3.91.917-9.913 5.986-9.913.536 0 2.802 2.405 6.193 2.405 3.39 0 5.657-2.405 6.193-2.405 5.069 0 5.986 6.003 5.986 9.913zM38.643 23.58c0 3.667-2.976 6.643-6.643 6.643s-6.643-2.976-6.643-6.643c0-3.668 2.976-6.643 6.643-6.643s6.643 2.975 6.643 6.643z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.583 31.932c0 16.376-13.275 29.651-29.652 29.651-16.375 0-29.65-13.275-29.65-29.651 0-16.376 13.275-29.65 29.65-29.65 16.377 0 29.652 13.274 29.652 29.65z",
    stroke: "#FFF",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeller);
export default __webpack_public_path__ + "static/media/seller.f0ab886a4eba23051dff5aec3d7543a3.svg";
export { ForwardRef as ReactComponent };